import React,{useState, createContext,useContext} from "react";
import { FileText } from "lucide-react";
import { Button } from "./button";
import { TriangleAlert } from "lucide-react";

export const CircleLoader = ({ showFileIcon=false, percentage = 0, size = 50, strokeWidth = 10, color = "#DE7538", trackColor = "#e0e0e0" }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <svg width={size} height={size}> 
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke={trackColor}
        strokeWidth={strokeWidth}
        fill="none"
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke={color}
        strokeWidth={strokeWidth}
        fill="none"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
        style={{ transition: 'stroke-dashoffset 0.5s ease' }}
      />
      { showFileIcon && <FileText color={trackColor} className={`w-5 h-5 transform translate-x-[14px] translate-y-[12px]`} />}
    </svg>
  );
};


const SectionContext = createContext();

export const CommentLoadSection = ({ children }) => {
  const [expanded,setExpanded]=useState(true);
  return (
    <SectionContext.Provider value={{ expanded, setExpanded }}>
      <div className='rounded-3xl  border-[var(--color-neutral-5)]'>
        {children}
      </div>
    </SectionContext.Provider>
  );
};

 CommentLoadSection.Header = ({ children,isError=false }) => {
  const fromColor=isError ? "from-system-negative-1": "from-[var(--color-misc-progress-orange-1)]";
  
  return (
    <div className={`rounded p-5 bg-gradient-to-r ${fromColor} to-[var(--color-neutral-1)]`}>
       {children}
    </div>
  );
};

 CommentLoadSection.HeaderAction = ({ expandedText,collapsedText,isError=false }) => {
  const { expanded, setExpanded } = useContext(SectionContext);
  const toggleDetails=()=>{
    setExpanded(!expanded);
  }
  const actionText=expanded ? expandedText:collapsedText;
  return (
    <Button variant="primaryOutline" size="default" onClick={toggleDetails} >{actionText} 
      </Button> 
  );
};


CommentLoadSection.Content = ({ children }) => {
  const { expanded } = useContext(SectionContext);
  
  return (
    <div 
      className={`grid transition-all duration-300 ease-in-out rounded bg-white ${
        expanded ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
      }`}
    >
      <div className="overflow-hidden">
        {children}
      </div>
    </div>
  );
};